import {
  HomePageLayoutBlueprint,
  HomePageWidgetData,
} from '@backstage/plugin-home-react/alpha';
import type { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import { HomeLandingPage } from './home-landing-page';

export const homeLandingPageLayout: ExtensionDefinition =
  HomePageLayoutBlueprint.make({
    params: {
      loader: async () =>
        function MyHomePageLayout({
          widgets,
        }: {
          widgets: HomePageWidgetData[];
        }) {
          return <HomeLandingPage widgets={widgets} />;
        },
    },
  });
